module.exports = __webpack_public_path__ + "static/media/MC.3823b2a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MC.svg
// module id = 308
// module chunks = 0